import React from 'react';
import { Box, HStack, Text, useStyleConfig } from '@chakra-ui/react';
import PropTypes from 'prop-types';

import { getLayerStyle } from '../../styles/theme/foundation/layerStyles';
import { getStatusDisplayName } from '../../utils/statusUtil';
import LoadingSpinner from '../Spinner';

const StatusBadge = ({
  size,
  status,
  minW,
  duskSelector = undefined,
  isFetching = undefined,
  cypressId = undefined
}) => {
  const layerStyle = getLayerStyle('status', status);
  const badgeStyles = useStyleConfig('StatusBadge', { size });

  const styles = { ...layerStyle, ...badgeStyles };

  return (
    <Box
      data-cy={cypressId}
      data-dusk-value={status}
      dusk={duskSelector}
      minW={minW}
      size={size}
      style={styles}
    >
      {isFetching
        ? (
          <HStack
            justifyContent="space-between"
          >
            <Text pr={4}>{getStatusDisplayName(status)}</Text>
            <LoadingSpinner isInline color="greyScale.500" ml={4} spinnerSize="sm" />
          </HStack>
        )
        : (<>{getStatusDisplayName(status)}</>)}
    </Box>
  );
};

StatusBadge.propTypes = {
  /** Height of badge, sets font size as well */
  size: PropTypes.oneOf(['sm', 'md', 'lg']),
  /** Status determines color, if status is not found, 'active' is returned */
  status: PropTypes.string,
  /** Defaults to 'auto' */
  minW: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  /** Selector for regression testing */
  duskSelector: PropTypes.string,
  /** Bool to show loading spinner if fetching new status */
  isFetching: PropTypes.bool,
  /** Selector for cypress e2e testing */
  cypressId: PropTypes.string
};

export default StatusBadge;
